// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MensagensProgramadasLote_GetFilteredCustomersInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /mensagens_programadas_lote/get_filtered_customers
 *
 * Filters customers eligible for bulk-scheduling messages by franchise IDs,
 * date range and a maximum count.
 */
import { registerContract } from './validate'

export interface MensagensProgramadasLote_GetFilteredCustomersInput {
franquia_ids: number[]
data_inicio: string
data_fim: string
quantidade: number
}

registerContract('MensagensProgramadasLote_GetFilteredCustomersInput', {
  franquia_ids: { type: 'array',   required: true },
  data_inicio:  { type: 'string',  required: true },
  data_fim:     { type: 'string',  required: true },
  quantidade:   { type: 'number',  required: true },
})
